import moment from 'moment';
import FileUrlUtils from '@/util/FileUrlUtils';

export default class DocutaxSubmissionSearchResult {
  /**
   * @type {number}
   */
  id;

  /**
   * @type {string}
   */
  status;

  /**
   * @type {number}
   */
  officeId;

  /**
   * @type {string}
   */
  officeEFIN;

  /**
   * @type {number}
   */
  assignedPreparerId;

  /**
   * @type {string}
   */
  assignedPreparerName;

  /**
   * @type {number}
   */
  clientId;

  /**
   * @type {string}
   */
  clientName;

  /**
   * @type {string}
   */
  clientCellPhone;

  /**
   * @type {string}
   */
  clientEmailAddress;

  /**
   * @type {string[]}
   */
  files = [];

  /**
   * @type {string}
   */
  message = '';

  /**
   * @type {number}
   */
  originatingRequestId;

  /**
   * @type {string}
   */
  originatingRequestPreparerName;

  /**
   * @type {string}
   */
  originatingRequestMessage;

  /**
   * @type {Moment}
   */
  originatingRequestCreatedDate;

  /**
   * @type {Moment}
   */
  createdDate;

  constructor(opts = null) {
    if (opts != null) {
      if (opts.id != null) {
        this.id = opts.id;
      }
      if (opts.status != null) {
        this.status = opts.status;
      }
      if (opts.officeId != null) {
        this.officeId = opts.officeId;
      }
      if (opts.officeEFIN != null) {
        this.officeEFIN = opts.officeEFIN;
      }
      if (opts.assignedPreparerId != null) {
        this.assignedPreparerId = opts.assignedPreparerId;
      }
      if (opts.assignedPreparerName != null) {
        this.assignedPreparerName = opts.assignedPreparerName;
      }
      if (opts.clientId != null) {
        this.clientId = opts.clientId;
      }
      if (opts.clientName != null) {
        this.clientName = opts.clientName;
      }
      if (opts.clientCellPhone != null) {
        this.clientCellPhone = opts.clientCellPhone;
      }
      if (opts.clientEmailAddress != null) {
        this.clientEmailAddress = opts.clientEmailAddress;
      }
      if (opts.files != null) {
        this.files = opts.files;
      }
      if (opts.message != null) {
        this.message = opts.message;
      }
      if (opts.originatingRequestId != null) {
        this.originatingRequestId = opts.originatingRequestId;
      }
      if (opts.originatingRequestPreparerName != null) {
        this.originatingRequestPreparerName = opts.originatingRequestPreparerName;
      }
      if (opts.originatingRequestMessage != null) {
        this.originatingRequestMessage = opts.originatingRequestMessage;
      }
      if (opts.originatingRequestCreatedDate != null) {
        if (moment.isMoment(opts.originatingRequestCreatedDate)) {
          this.originatingRequestCreatedDate = opts.originatingRequestCreatedDate;
        } else {
          this.originatingRequestCreatedDate = moment(opts.originatingRequestCreatedDate.date);
        }
      }
      if (opts.createdDate != null) {
        if (moment.isMoment(opts.createdDate)) {
          this.createdDate = opts.createdDate;
        } else {
          this.createdDate = moment(opts.createdDate.date);
        }
      }
    }
  }

  /**
   * @returns string[]
   */
  getImageUrls() {
    return this.files.filter((filename) => {
      const fileType = FileUrlUtils.getFileType(filename);

      return ['jpg', 'png', 'jpeg', 'gif'].includes(fileType);
    });
  }

  /**
   * @returns string[]
   */
  getPDFUrls() {
    return this.files.filter((filename) => {
      const fileType = FileUrlUtils.getFileType(filename);

      return fileType === 'pdf';
    });
  }

  /**
   * @returns string[]
   */
  getHeicUrls() {
    return this.files.filter((filename) => {
      const fileType = FileUrlUtils.getFileType(filename);

      return fileType === 'heic';
    });
  }

  /**
   * @returns int
   */
  getTotalHeicAndImageUrlCount() {
    return this.getImageUrls().length + this.getHeicUrls().length;
  }

  /**
   * @returns string[]
   */
  getUnsupportedFileTypes() {
    return this.files.filter((filename) => {
      const fileType = FileUrlUtils.getFileType(filename);

      return !['jpg', 'png', 'jpeg', 'gif', 'pdf', 'heic'].includes(fileType);
    });
  }
}
